module.exports = __webpack_public_path__ + "img/error.78c31c52.svg";